import { Component, OnInit, Input, Output, OnChanges, ViewChild, AfterViewInit, EventEmitter } from '@angular/core';
import { formatDate } from '@angular/common';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SettingsService } from 'src/app/services/settings.service';
import { UserService } from 'src/app/services/user.service';
import { UserFiaPins } from 'src/app/shared/models/users/user-fia-pins';
import { UserProfile } from 'src/app/shared/models/users/user-profile';
import * as XLSX from 'xlsx';
import { FiaService } from 'src/app/services/fia.service';

@Component({
  selector: 'app-fia-pins',
  templateUrl: './fia-pins.component.html',
  styleUrls: ['./fia-pins.component.scss'],
})
export class FiaPinsComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('userFiaPinsModal', { static: true }) userFiaPinsModal: any;

  @Input() selectedUserProfile: UserProfile;
  @Input() selectedUserFiaPins: UserFiaPins[] = [];
  @Input() showModal: boolean = false;

  @Output() showModalChange = new EventEmitter<boolean>();

  busy: boolean = false;
  showError: boolean;
  errorMsg: string = '';

  userProfile: UserProfile = new UserProfile();
  userFiaPins: UserFiaPins[] = [];
  selectedFiaPin: UserFiaPins = null;

  totalAmountAvailable: number = 0;

  constructor(
    public settingsService: SettingsService,
    public usersService: UserService,
    public fiaService: FiaService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {}

  ngOnChanges() {
    this.showHideModal(null);
  }

  ngAfterViewInit(): void {}

  onClosed(event: any) {
    if (this.showModal != false) {
      this.showModal = false;
      this.showModalChange.emit(this.showModal);
    }
  }

  showHideModal(toggle: boolean) {
    if (toggle != null) {
      this.showModal = toggle;
    }

    if (this.showModal) {
      this.userFiaPinsModal.show();
      this.userProfile = <UserProfile>JSON.parse(JSON.stringify(this.selectedUserProfile));
      this.userFiaPins = <UserFiaPins[]>JSON.parse(JSON.stringify(this.selectedUserFiaPins));
      this.totalAmountAvailable = UserFiaPins.calculatePinAvailableAmount(this.userFiaPins);
    } else if (!this.showModal) {
      // Blur any focused element before hiding modal to prevent aria-hidden warning
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      this.userProfile = null;
      this.userFiaPins = [];
      this.selectedFiaPin = null;
      this.userFiaPinsModal.hide();
    }

    this.showModalChange.emit(this.showModal);
  }

  editPinClicked(userPin: UserFiaPins) {
    userPin.edit = true;
    this.selectedFiaPin = userPin;
  }

  SavePin() {
    if (this.selectedFiaPin.pinBalance == 0 || this.selectedFiaPin.reservedAmount > this.selectedFiaPin.pinAmount) {
      this.showError = true;
      this.errorMsg = 'Cannot edit pin, Pin Balance is zero or the Reserved Amount is greater than the Pin Amount';
    } else {
      this.busy = true;
      this.fiaService.UpdateFiaPin(this.selectedFiaPin).subscribe(
        (response: UserFiaPins) => {
          this.showError = false;
          this.busy = false;
          this.selectedFiaPin = null;
          this.GetUsersFiaPins(this.userProfile.userId);
        },
        (error) => {
          this.showError = true;
          this.errorMsg = error.error.ErrorDetail;
          this.busy = false;
        }
      );
    }
  }

  canEdit(userPin: UserFiaPins): boolean {
    if (!this.selectedFiaPin) {
      return true;
    } else if (userPin.id == this.selectedFiaPin.id) {
      return true;
    }
    return false;
  }

  GetUsersFiaPins(userId: number) {
    return new Promise((resolve) => {
      this.busy = true;
      this.usersService.GetUsersFiaPins(userId, false).subscribe(
        (response) => {
          this.userFiaPins = response;
          this.busy = false;
          resolve(true);
        },
        (error) => {
          this.showError = true;
          this.errorMsg = error.error.ErrorDetail;
          this.busy = false;
          resolve(true);
        }
      );
    });
  }

  HasPinExpired(pin: UserFiaPins) {
    return UserFiaPins.hasPinExpired(pin);
  }

  Extract(idselector: string) {
    var filename = this.userProfile.fullName.replace(' ', '_') + '_FiaPinExtract_';
    let element = document.getElementById(idselector);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename + formatDate(new Date(), 'yyyyMMdd', 'en') + '.xlsx');
  }
}
